import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Blog from './components/Blog';
import FAQ from './components/FAQ';
import ContactUs from './components/ContactUs';
import SquadPage from './components/SquadPage';
import FindMySquad from './components/FindMySquad';
import { trackPageView } from './utils/analytics';
import './App.css';

// Component to track page views on route changes
function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view when route changes
    const pageName = location.pathname === '/' ? 'Landing Page' : location.pathname.slice(1);
    trackPageView(pageName, {
      path: location.pathname,
    });
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <PageViewTracker />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/find-my-squad" element={<FindMySquad />} />
        <Route path="/e/:eventId/s/:squadId" element={<SquadPage />} />
      </Routes>
    </Router>
  );
}

export default App;
